export default __webpack_public_path__ + "static/media/close.069e609e.svg";